<template lang="pug">
  .edit-sub-choose-date.narrow-modal-body
    .icon-calendar.text-center.color-mr-purple.xs-f-xxlarge.max-at-tweak
    SectionTitle(text="Choose Ship Date").app-modal-title
    .row.choose-wrap
      p.color-slate.text-center.xs-f-small.lg-f-medium.max-at-tweak When would you like us to ship your next box?

      NextDateSelector.xs-12(:subId="subInEdit.id", :nextDate="postponeDate" @onDateSelect="setPostponeDate" data-mr-ass="next-date-selector")

    .row
      SubmitButtons(
        submit-text="Save"
        :submit-method="submitModal"
        :submit-disabled="savingSub"
        cancel-text="Close"
        :cancel-method="hideModal"
        :cancel-disabled="savingSub"
      )
  
</template>

<script>
  import { mapState, mapActions, mapMutations } from 'vuex';
  import SectionTitle from "../../../SectionTitle";
  import SubmitButtons from "../../../SubmitButtons";
  import NextDateSelector from "../NextDateSelector";
  export default {
    name: "EditAutoDeliveryChooseDateModal",
    components: {
      NextDateSelector,
      SubmitButtons,
      SectionTitle
    },

    data() {
      return {
        nextDate: null,
        postponeDate: null,
      }
    },

    created() {
      this.postponeDate = this.subInEdit.next;
    },

    computed: {
      ...mapState('subscriptions', [
        'subInEdit',
        'savingSub',
        'cancelData'
      ])
    },

    methods: {
      ...mapActions('subscriptions', [
        'updateSubscription'
      ]),

      ...mapActions('modal', [
        'hideModal'
      ]),

      ...mapMutations('subscriptions', [
        'clearSubInEdit'
      ]),

      setPostponeDate(date) {
        this.postponeDate = date;
      },

      submitModal() {
        let next = this.$moment(this.postponeDate).format('YYYY-MM-DD');
        let payload = {
          sub_id: this.subInEdit.id,
          changes: { next: next }
        };

        this.updateSubscription(payload).then(() => {
          this.trackEvent('Cancel flow save ship date', this.cancelData);
          this.clearSubInEdit();
          this.hideModal();
          this.$router.push({ name: 'subDashboard' });
        });
      }
    }
  }
</script>

<style scoped lang="stylus">
  .edit-sub-choose-date
    .choose-wrap
      padding-bottom 1em

      > p
        padding 0.5em 0 1em
</style>